module.exports = __webpack_public_path__ + "static/media/left-arrow-disabled.5e675068.svg";